AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "Hint");

AoPS.Ebooks.Models.Hint = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var EbkMBase = AoPS.Ebooks.Models.Base;

	return EbkMBase.BaseModel.extend({
		id_attribute: "hint_id",
		defaults: {
			has_viewed: false,
			is_shown: false,
			hint_html: "",
		},
		/** Additional attributes:
			book: Book model owning this one; guaranteed to be set
		*/

		view: function (callback, context) {
			function onView(ok, data) {
				if (!ok) {
					return callback(ok, data);
				}
				this.unpack(data.response.hint);
				this.set("is_shown", true);
				callback(ok, {});
			}

			callback = LoadUtils.makeCallback(callback, context);

			if (this.get("has_viewed") && this.get("hint_html")) {
				this.set("is_shown", true);
				setTimeout(callback(true, {}), 1);
				return;
			}

			var book = this.get("book");
			EbkMBase.ajax.run(
				"view_hint",
				{
					user_id: book.get("master").get("user_id"),
					book_id: book.id,
					hint_id: this.id,
				},
				_.bind(onView, this)
			);
		},
	});
})();
